var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 22.5277C33 25.4783 30.6464 27.8702 27.7432 27.8702C24.8399 27.8702 22.4864 25.4783 22.4864 22.5277C22.4864 19.5771 24.8399 17.1851 27.7432 17.1851C30.6464 17.1851 33 19.5771 33 22.5277Z",
    fill: "#1ABCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4864 17.1851H17.2296C14.3414 17.1851 12 14.7779 12 11.8426C12 8.90723 14.3414 6.5 17.2296 6.5H22.4864V17.1851Z",
    fill: "#FF7262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4864 27.8702H17.2296C14.3414 27.8702 12 25.463 12 22.5277C12 19.5924 14.3414 17.1851 17.2296 17.1851H22.4864V27.8702Z",
    fill: "#FF7262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33.1851C12 30.2498 14.3414 27.8702 17.2296 27.8702H22.5136V33.1851C22.5136 36.1204 20.145 38.5 17.2568 38.5C14.3686 38.5 12 36.1204 12 33.1851Z",
    fill: "#0ACF83"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4864 17.1851H27.7432C30.6314 17.1851 32.9728 14.7779 32.9728 11.8426C32.9728 8.90723 30.6314 6.5 27.7432 6.5H22.4864V17.1851Z",
    fill: "#FF7262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.14607d3fd2bdfb0a221fabf98503308d.svg";
export { ForwardRef as ReactComponent };